import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
	TReportsStore,
	TGetSalesReportsResponsePayload,
	TGetSalesReportsRequestPayload,
	TDownloadSalesReportRequestPayload,
	TDownloadSalesReportResponsePayload,
	TGetVatReportsRequestPayload,
	TGetVatReportsResponsePayload,
	TDownloadVatReportRequestPayload,
	TDownloadVatReportsResponsePayload,
} from './types';

export const initialState: TReportsStore = {
	salesReports: null,
	salesReportsLoader: false,
	downloadSalesReport: null,
	downloadSalesReportLoader: false,
	vatReports: null,
	vatReportsLoader: false,
	downloadVatReportLoader: false,
};

// ==========================================:

const reports = createSlice({
	name: '@@reports',
	initialState,
	reducers: {
		getSalesReportsRequest: (
			state: TReportsStore,
			action: PayloadAction<TGetSalesReportsRequestPayload>,
		) => {
			const reportsState = state;
			reportsState.salesReports = null;
			reportsState.salesReportsLoader = true;
		},
		getSalesReportsSuccess: (
			state: TReportsStore,
			action: PayloadAction<TGetSalesReportsResponsePayload>,
		) => {
			const { payload } = action;
			const reportsState = state;
			reportsState.salesReports = payload;
			reportsState.salesReportsLoader = false;
		},
		downloadSalesReportRequest: (
			state: TReportsStore,
			action: PayloadAction<TDownloadSalesReportRequestPayload>,
		) => {
			const reportsState = state;
			reportsState.downloadSalesReport = null;
			reportsState.downloadSalesReportLoader = true;
		},
		downloadSalesReportSuccess: (
			state: TReportsStore,
			action: PayloadAction<TDownloadSalesReportResponsePayload>,
		) => {
			const { payload } = action;
			const reportsState = state;
			reportsState.downloadSalesReport = payload;
			reportsState.downloadSalesReportLoader = false;
		},
		setDownloadedSalesReport: (state: TReportsStore) => {
			const reportsState = state;
			// reportsState.downloadSalesReport = null;
		},
		getVatReportsRequest: (
			state: TReportsStore,
			action: PayloadAction<TGetVatReportsRequestPayload>,
		) => {
			const reportsState = state;
			reportsState.vatReports = null;
			reportsState.vatReportsLoader = true;
		},
		getVatReportsSuccess: (
			state: TReportsStore,
			action: PayloadAction<TGetVatReportsResponsePayload>,
		) => {
			const { payload } = action;
			const reportsState = state;
			reportsState.vatReports = payload;
			reportsState.vatReportsLoader = false;
		},
		downloadVatReportRequest: (
			state: TReportsStore,
			action: PayloadAction<TDownloadVatReportRequestPayload>,
		) => {
			const reportsState = state;
			reportsState.downloadVatReportLoader = true;
		},
		downloadVatReportsSuccess: (
			state: TReportsStore,
			action: PayloadAction<TDownloadVatReportsResponsePayload>,
		) => {
			const { payload } = action;
			const reportsState = state;
			reportsState.downloadVatReportLoader = false;
		},
		setDownloadedVatReport: (state: TReportsStore) => {
			const reportsState = state;
			// reportsState.downloadVatReportImport = null;
		},

		reportsInitState: () => initialState,
	},
});

export default reports.reducer;
export const {
	getSalesReportsRequest,
	getSalesReportsSuccess,
	downloadSalesReportRequest,
	downloadSalesReportSuccess,
	setDownloadedSalesReport,
	getVatReportsRequest,
	getVatReportsSuccess,
	downloadVatReportRequest,
	downloadVatReportsSuccess,
	setDownloadedVatReport,
	reportsInitState,
} = reports.actions;
